import { motion } from "framer-motion";

export default function GaleriaSection() {
  const images = [
    "/images/foto2.jpg",
    "/images/foto1.jpg",
    "/images/foto17.jpg",
    "/images/foto18.jpg",
    "/images/foto26.jpg",
    "/images/foto19.jpg",
    "/images/foto20.jpg",
    "/images/foto21.jpg",
    "/images/foto22.jpg",
    "/images/foto23.jpg",
    "/images/foto24.jpg",
    "/images/foto27.jpg",
  ];

   return (
    <section className="bg-white py-16 px-4">
      {/* Nagłówek */}
      <h2 className="text-3xl md:text-4xl font-heading text-center text-accent mb-8 tracking-wide">
        <span className="inline-block border-t border-b-2 border-accent px-4 py-1">
          GALERIA
        </span>
      </h2>

      {/* Galeria */}
      <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {images.map((src, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.05 }}
            viewport={{ once: true, amount: 0.2 }}
            className="relative w-full aspect-square overflow-hidden rounded-md shadow-sm"
          >
            <img
              src={src}
              alt={`gallery-${index}`}
              className="absolute inset-0 w-full h-full object-cover transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
}